import React from "react";
import { Link, Outlet } from "react-router";
import { Container, Navbar, Nav } from "react-bootstrap";
import brandIcon from "assets/images/icon.png";
import ThemeToggle from "components/shared/ThemeToggle";
import Footer from "components/shared/Footer";
import Seo from "components/shared/Seo";

const AnonymousLayout = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            {/* Baseline SEO defaults; pages render their own Seo to override per-route values */}
            <Seo />
            <Navbar
                variant="dark"
                bg="dark"
                expand="lg"
                sticky="top"
                collapseOnSelect={true}
            >
                <Container>
                    <Navbar.Brand
                        href="/"
                        className="d-flex align-items-center"
                    >
                        <img
                            alt=""
                            src={brandIcon}
                            width="30"
                            height="30"
                            className="d-inline-block"
                        />{" "}
                        Wishliz
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="#" as={Link} to="/">
                                Home
                            </Nav.Link>
                            <Nav.Link
                                href="#"
                                as={Link}
                                to="/subscription/pricing"
                            >
                                Pricing
                            </Nav.Link>
                            <Nav.Link href="#" as={Link} to="/help">
                                Help
                            </Nav.Link>
                        </Nav>

                        <Nav>
                            <Nav.Item className="me-2 d-flex align-items-center">
                                <ThemeToggle />
                            </Nav.Item>
                            <Nav.Link href="#" as={Link} to="/account/signin">
                                Sign In
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
            <Footer />
        </div>
    );
};

export default AnonymousLayout;
